import React, { useState } from "react";
import { Box, Card, CardContent, Typography, Button, Grid, Divider } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { motion } from "framer-motion";
import AutoPopUp from "./AutoPopUp";
import { Navigate, useNavigate } from "react-router-dom";

const categories = [
    {
        title: "Engineering",
        links: [
            "Two Year First Step Integrated Classroom Course for JEE (Main and Advanced)",
            "Two Year Second Step Integrated and  Non-Integrated Course for JEE Main and KCET",
            "40-Day Crash Course for KCET"],
    },
    {
        title: "Medical",
        links: [
            "Two Year Integrated Classroom Course for NEET",
            "One Year XII cum Medical Classroom Course for NEET",
            "40-Day Crash Course for NEET"],
    },
    {
        title: "Olympiads & Boards",
        links: [
            "One Year Integrated Classroom Course for Olympiads, NTSE & Class Vl to X",
            "Two Year Integrated Classroom Course for Olympiads, NTSE & Class IX to X",
        ],
    },
];

const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const Courses = () => {

    const [openPopup, setOpenPopup] = useState(false);
    const navigate =useNavigate();
    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    return (
        <Box sx={{ p: { xs: 3, md: 6 }, backgroundColor: "#e0f5fe" }}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
            >
                <Typography variant="h5" align="center" fontWeight={700} gutterBottom>
                    Popular Courses
                </Typography>
            </motion.div>
            <Grid container spacing={2} justifyContent="center" sx={{ mt: 1 }}>
                {categories.map((category, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <motion.div initial="hidden" whileInView="visible" variants={cardVariants} viewport={{ once: true }}>
                            <Card
                                sx={{
                                    borderRadius: 3,
                                    boxShadow: 4,
                                    overflow: "hidden",
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": { transform: "scale(1.05)" },
                                }}
                            >
                                <Box sx={{ backgroundColor: "#00aeef", p: 2, color: "white", textAlign: "center" }}>
                                    <Typography variant="h6" fontWeight={600} sx={{ fontSize: { xs: "1rem", md: "1.2rem" } }}>
                                        {category.title}
                                    </Typography>
                                </Box>
                                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                                    {category.links.map((link, idx) => (
                                        <Box
                                            key={idx}
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            mb={1.5}
                                            flexDirection={{ xs: "column", sm: "row" }}
                                            textAlign={{ xs: "center", sm: "left" }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    color: "#333",
                                                    fontWeight: 500,
                                                    fontSize: { xs: "0.85rem", md: "1rem" },
                                                }}
                                            >
                                                <Box component="span" sx={{ color: "#0077b6", fontSize: "1.2rem", mr: 1 }}>•</Box>
                                                {link}
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: "#e3f2fd",
                                                    color: "#0077b6",
                                                    width: "150px",
                                                    borderRadius: "20px",
                                                    textTransform: "none",
                                                    fontWeight: 600,
                                                    fontSize: { xs: "10px", md: "11px" },
                                                    boxShadow: "none",
                                                    transition: "0.3s",
                                                    mt: { xs: 1, sm: 0 },
                                                    "&:hover": { backgroundColor: "#bbdefb" },
                                                }}
                                                onClick={() => setOpenPopup(true)}
                                            >
                                                Apply Now
                                            </Button>
                                        </Box>
                                    ))}
                                </CardContent>
                                <Divider />
                                <Box sx={{ textAlign: "center", pb: 3, pt: 2 }}>
                                    <Typography
                                        component={motion.div}
                                        whileHover={{ scale: 1.1 }}
                                        color="#0077b6"
                                        sx={{ cursor: "pointer", fontWeight: 600, textDecoration: "underline", fontSize: { xs: "0.9rem", md: "1rem" } }}
                                        onClick={()=>navigate("/course-details")}
                                    >
                                        Check More
                                    </Typography>
                                </Box>
                            </Card>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>
            <AutoPopUp isOpen={openPopup} onClose={handleClosePopup} />
        </Box>
    );
};

export default Courses;